export default __webpack_public_path__ + "static/media/search.eacc2e97.svg";